if (typeof G == 'undefined') G = {};
G.Animations = G.Animations || {};
G.Animations.Generic = G.Animations.Generic || {};

G.Animations.Generic.createFadeInAnimation = (
  function createFadeInAnimation(duration) {
    return { animate: animate };
    function animate(game, target) {
      target.visible = true;
      target.exists = true;
      game.add.tween(target).to(
        { alpha: 1 },
        duration, Phaser.Easing.Cubic.Out, true
      );
    }
  }
);

